import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import ConfigModule from '@/modules/config';
import MenuModule from '@/modules/menu';
import HorariosModule from '@/modules/horarios';


export default new Vuex.Store({
  modules: {
    config: ConfigModule,
    menu: MenuModule,
    horarios: HorariosModule
  }
})
